import { Flex } from "@radix-ui/themes";
import React, { forwardRef } from "react";
import { Button } from "@chakra-ui/react";
import SpaceIcon from "../../atom/icons/SpaceIcon";

const SpaceAddButton = forwardRef<HTMLButtonElement, React.ButtonHTMLAttributes<HTMLButtonElement>>(
  ({ onClick, color, style, ...props }, ref) => {
    return (
      <Flex
        align={"center"}
        justify={"center"}
        asChild
      >
        <Button
          size="sm"
          w="24px"
          h="24px"
          minW={"initial"}
          p={0}
          m={0}
          borderRadius="5px"
          verticalAlign={"initial"}
          fontSize={"24px"}
          bg={color ? `${color}33` : "rgba(171, 173, 173, 0.2)"}
          _hover={{ bg: color ? `${color}66` : "rgba(171, 173, 173, 0.40)", cursor: "pointer" }}
          _active={{ bg: color ? `${color}66` : "rgba(171, 173, 173, 0.40)", cursor: "pointer" }}
          zIndex={10}
          onClick={onClick}
          ref={ref}
          {...props}
        >
          <SpaceIcon color={color ?? "#ABADAD"} />
        </Button>
      </Flex>
    );
  }
);

export default SpaceAddButton;
